import { useCallback } from 'react';

import {
  Button,
  Input,
  Label,
  QuantityContent,
  QuantityWrapper,
} from '@/modules/common/components/quantity/Quantity.styles';

const MAX = 99;

export const Quantity = ({ value, changeValue }: { value: string; changeValue: (newValue: string) => void }) => {
  const onClickDown = useCallback(() => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue > 1) {
      changeValue(String(numericValue - 1));
    }
  }, [value, changeValue]);

  const onClickUp = useCallback(() => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue) && numericValue < MAX) {
      changeValue(String(numericValue + 1));
    } else if (numericValue > MAX) {
      alert(1);
      changeValue(String(MAX));
    }
  }, [value, changeValue]);

  const onChangeInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;
      if (/^\d*$/.test(inputValue)) {
        changeValue(inputValue);
      }
    },
    [changeValue]
  );

  const onBlurInput = useCallback(() => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue)) {
      if (numericValue < 1) {
        changeValue('1');
      } else if (numericValue > MAX) {
        changeValue(String(MAX));
      }
    }
  }, [value, changeValue]);

  return (
    <QuantityWrapper>
      <div>
        <Label>Quantity:</Label>
      </div>
      <QuantityContent>
        <Button onClick={onClickDown}>-</Button>
        <Input type="text" onChange={onChangeInput} onBlur={onBlurInput} value={value} />
        <Button onClick={onClickUp}>+</Button>
      </QuantityContent>
    </QuantityWrapper>
  );
};
